var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export * from './header';
export * from './task';
export * from './dependency';
export * from './animated-view';
export * from './add-button';
import { shapes } from '@joint/plus';
import { Header } from './header';
import { Task } from './task';
import { Dependency } from './dependency';
import { AddButton } from './add-button';
export var cellNamespace = __assign(__assign({}, shapes), { kanban: {
        Dependency: Dependency,
        Header: Header,
        Task: Task,
        AddButton: AddButton
    } });
